<template>
  <div class="l-select" :class="{ 'l-select--opened': showPopper }" @click="togglePopper" @keydown.38="scrollByArrow" @keydown.40="scrollByArrow" @keydown.enter="onEnter">
    <span v-if="multiple" class="l-select__tag">
      <span ref="tags">
        <template v-for="(item, index) in selected">
          <span v-if="collapseTags && index < 1" :key="item.value" class="l-select__tag-item">
            {{ item.label }}
            <font-awesome-icon icon="times" class="text-3xs text-gray-600" @click.stop="onRemoveTag(item)" />
          </span>
          <span v-if="collapseTags && index === 1" :key="item.value" class="l-select__tag-item l-select__tag-item--collapsed" >+{{ selected.length - 1 }}</span>
          <span v-if="!collapseTags" :key="item.value" class="l-select__tag-item">
            {{ item.label }}
            <font-awesome-icon icon="times" class="text-3xs text-gray-600" @click.stop="onRemoveTag(item)" />
          </span>
        </template>
      </span>
    </span>

    <l-input ref="input" v-model="selected.label" :readonly="true" :placeholder="computedPlaceholder" :name="name" >
      <font-awesome-icon slot="suffix" icon="chevron-down" class="text-3xs text-grey-600" />
    </l-input>
    <l-popper v-if="showPopper" ref="popper" v-click-outside="onClosePopper" :append-to="appendEl" :full-size="true" >
      <div ref="list" class="l-select__option-list">
        <div v-if="!data.length" class="text-3xs text-grey-600">{{ emptyText }}</div>
        <slot v-else />
      </div>
    </l-popper>
  </div>
</template>

<script>
import LInput from "../input/LInput.vue";
import LPopper from "../popper/LPopper.vue";
//import { clickOutside } from "./directives";
import vClickOutside from "v-click-outside";

export default {
  name: "LSelect",

  components: {
    [LInput.name]: LInput,
    [LPopper.name]: LPopper
  },

  provide() {
    return {
      select: this
    };
  },

  model: {
    prop: "value",
    event: "change"
  },

  props: {
    data: Array,
    value: [String, Number, Array, Boolean],
    placeholder: String,
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: "Empty list"
    },
    name: String
  },

  data() {
    return {
      q: "",
      appendEl: "",
      selected: this.multiple ? [] : {},
      showPopper: false,
      aheadPointer: 0,
      pointerPosTop: null,
      viewportHeight: null,
      tagsHeight: null
    };
  },

  computed: {
    computedPlaceholder() {
      if (this.multiple) {
        return this.selected.length === 0 ? this.placeholder : "";
      }
      return this.placeholder;
    },
    computedData() {
      return this.data.filter(f => {
        return f.label.indexOf(this.q) !== -1;
      });
    }
  },

  watch: {
    showPopper(v) {
      if (v) {
        this.$nextTick(() => {
          this.getViewportHeight();
          this.getPointerPosTop();
        });
        this.$refs.input.$el.querySelector("input").focus();
      }
    },
    value() {
      this.setInitValue();
      if (this.multiple) this.refreshInputHeight();
    },
    q() {
      //console.log("dsads", this.q);
    }
  },

  created() {
    this.setInitValue();
    this.$on("option:select", e => {
      if (this.multiple) {
        this.addItem(e);
        this.refreshInputHeight();
        this.$emit("change", this.selected);
        this.$refs.popper.update();
      } else {
        this.selected = e;
        this.$emit("change", e.value);
        this.onClosePopper();
      }
    });
  },

  mounted() {
    this.appendEl = this.$el;
    this.refreshInputHeight();
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  methods: {
    setInitValue() {
      if (!this.value) {
        this.selected = this.multiple ? [] : {};
        return;
      }

      if (this.multiple) {
        this.selected = this.value.map(item => {
          return this.data.find(i => i.value === item.value);
        });
      } else {
        this.selected = this.data.find(item => item.value === this.value);
      }
    },
    togglePopper() {
      if (this.disabled) return;
      this.showPopper = !this.showPopper;
    },
    onClosePopper() {
      if (this.showPopper) {
        this.showPopper = false;
        this.$emit("closePopper");
      }
    },
    onEnter() {
      const item = this.data[this.aheadPointer];

      if (this.multiple) {
        this.addItem(item);
        this.$emit("change", this.selected);
      } else {
        this.$emit("change", item.value);
      }
      this.showPopper = false;
    },
    getViewportHeight() {
      this.viewportHeight = this.$refs.popper.$el.offsetHeight;
    },
    getPointerPosTop() {
      this.pointerPosTop = this.$refs.list.children[this.aheadPointer];
      return this.pointerPosTop ? this.pointerPosTop.offsetTop : 10;
    },
    getTagsHeight() {
      if (!this.multiple) return;

      this.tagsHeight = this.$refs.tags.offsetHeight;
    },
    setInputHeight() {
      if (!this.multiple) return;

      const inputEL = this.$refs.input.$el.querySelector("input");

      if (this.tagsHeight > 32) {
        inputEL.style.height = this.tagsHeight + 14 + "px";
      } else {
        inputEL.style.height = 32 + "px";
      }
    },
    addItem(item) {
      if (item.disabled) return;

      const index = this.selected.findIndex(i => i.value === item.value);
      index === -1 ? this.selected.push(item) : this.selected.splice(index, 1);
    },
    scrollByArrow(e) {
      if (!this.data || !this.showPopper) return;

      const optionItemHeight = this.$refs.list.children[0].offsetHeight;
      const popperInner = this.$refs.popper.$el.querySelector(
        ".l-popper__inner"
      );
      const offsetTop = 10;
      const offsetBottom = 6;

      if (e.keyCode === 38) {
        if (this.aheadPointer > 0) this.aheadPointer--;
        this.getPointerPosTop();
      }
      if (e.keyCode === 40) {
        if (this.aheadPointer < this.data.length - 1) this.aheadPointer++;
        this.getPointerPosTop();
      }
      if (this.pointerPosTop < popperInner.scrollTop) {
        popperInner.scrollTop = this.pointerPosTop - offsetTop;
      }
      if (
        this.pointerPosTop >
        popperInner.scrollTop + this.viewportHeight - optionItemHeight
      ) {
        popperInner.scrollTop =
          this.pointerPosTop -
          this.viewportHeight +
          optionItemHeight +
          offsetBottom;
      }
    },
    refreshInputHeight() {
      this.$nextTick(() => {
        this.getTagsHeight();
        this.setInputHeight();
      });
    },
    onRemoveTag(tag) {
      const index = this.selected.findIndex(item => item.value === tag.value);
      this.$emit("remove-tag", this.selected[index]);
      this.selected.splice(index, 1);
      this.$emit("change", this.selected);
      if (this.showPopper) this.$refs.popper.update();
    }
  }
};
</script>

<style lang="postcss">
.l-select {
  @apply cursor-pointer inline-block relative w-full;
}
.l-select__tag {
  @apply absolute flex items-center flex-wrap z-10 h-8;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2px 40px 2px 5px;
}
.l-select__tag-item {
  @apply text-3xs bg-gray-300 border rounded flex-shrink-0 inline-block;
  box-sizing: border-box;
  padding: 2px 5px;
  margin: 2px;
}

.l-select .l-input .l-input__inner {
  @apply pl-2;
}

.l-popper__inner .l-input {
  @apply mb-2;
}
</style>
